/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { useParams } from 'react-router-dom';

import { EmbeddedTelemetryViewer } from '@/components/EmbeddedTelemetryViewer/EmbeddedTelemetryViewer';

export function PluginsPage() {
  const { pluginId } = useParams<{ pluginId: string }>();
  const path = pluginId ? `/plugins/${pluginId}` : '/plugins';
  return <EmbeddedTelemetryViewer path={path} iframeTitle="Node Plugins" />;
}
